/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompletionRuleContract,
  SelfControlSignResult,
  WorkPreparationCompletionContract,
  WorkPreparationReadiness
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiWorkPreparationProjectIdReadiness = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<WorkPreparationReadiness>(
      {url: `/api/work-preparation/${projectId}/readiness`, method: 'GET', signal
    },
      );
    }




export const getGetApiWorkPreparationProjectIdReadinessQueryKey = (projectId: number,) => {
    return [
    `/api/work-preparation/${projectId}/readiness`
    ] as const;
    }


export const getGetApiWorkPreparationProjectIdReadinessQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkPreparationProjectIdReadinessQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>> = ({ signal }) => getApiWorkPreparationProjectIdReadiness(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkPreparationProjectIdReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>>
export type GetApiWorkPreparationProjectIdReadinessQueryError = ErrorType<unknown>


export function useGetApiWorkPreparationProjectIdReadiness<TData = Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkPreparationProjectIdReadiness<TData = Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkPreparationProjectIdReadiness<TData = Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkPreparationProjectIdReadiness<TData = Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationProjectIdReadiness>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkPreparationProjectIdReadinessQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiWorkPreparationProjectIdAdvanceStatus = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<WorkPreparationReadiness>(
      {url: `/api/work-preparation/${projectId}/advance-status`, method: 'POST', signal
    },
      );
    }




export const getPostApiWorkPreparationProjectIdAdvanceStatusMutationKey = () => ['postApiWorkPreparationProjectIdAdvanceStatus'] as const;

export const getPostApiWorkPreparationProjectIdAdvanceStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdAdvanceStatus>>, TError,PostApiWorkPreparationProjectIdAdvanceStatusMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdAdvanceStatus>>, TError,PostApiWorkPreparationProjectIdAdvanceStatusMutationVariables, TContext> => {

const mutationKey = getPostApiWorkPreparationProjectIdAdvanceStatusMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdAdvanceStatus>>, PostApiWorkPreparationProjectIdAdvanceStatusMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiWorkPreparationProjectIdAdvanceStatus(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkPreparationProjectIdAdvanceStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdAdvanceStatus>>>

    export type PostApiWorkPreparationProjectIdAdvanceStatusMutationError = ErrorType<unknown>
    export type PostApiWorkPreparationProjectIdAdvanceStatusMutationVariables = {projectId: number}

    export const usePostApiWorkPreparationProjectIdAdvanceStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdAdvanceStatus>>, TError,PostApiWorkPreparationProjectIdAdvanceStatusMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkPreparationProjectIdAdvanceStatus>>,
        TError,
        PostApiWorkPreparationProjectIdAdvanceStatusMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiWorkPreparationProjectIdAdvanceStatusMutationOptions(options), queryClient);
    }
    export const getApiWorkPreparationCompletionDefinitions = (

 signal?: AbortSignal
) => {


      return customInstance<WorkPreparationCompletionContract>(
      {url: `/api/work-preparation/completion-definitions`, method: 'GET', signal
    },
      );
    }




export const getGetApiWorkPreparationCompletionDefinitionsQueryKey = () => {
    return [
    `/api/work-preparation/completion-definitions`
    ] as const;
    }


export const getGetApiWorkPreparationCompletionDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkPreparationCompletionDefinitionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>> = ({ signal }) => getApiWorkPreparationCompletionDefinitions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkPreparationCompletionDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>>
export type GetApiWorkPreparationCompletionDefinitionsQueryError = ErrorType<unknown>


export function useGetApiWorkPreparationCompletionDefinitions<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkPreparationCompletionDefinitions<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkPreparationCompletionDefinitions<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkPreparationCompletionDefinitions<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkPreparationCompletionDefinitionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiWorkPreparationCompletionDefinitionsRescuePlan = (

 signal?: AbortSignal
) => {


      return customInstance<CompletionRuleContract>(
      {url: `/api/work-preparation/completion-definitions/rescue-plan`, method: 'GET', signal
    },
      );
    }




export const getGetApiWorkPreparationCompletionDefinitionsRescuePlanQueryKey = () => {
    return [
    `/api/work-preparation/completion-definitions/rescue-plan`
    ] as const;
    }


export const getGetApiWorkPreparationCompletionDefinitionsRescuePlanQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkPreparationCompletionDefinitionsRescuePlanQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>> = ({ signal }) => getApiWorkPreparationCompletionDefinitionsRescuePlan(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkPreparationCompletionDefinitionsRescuePlanQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>>
export type GetApiWorkPreparationCompletionDefinitionsRescuePlanQueryError = ErrorType<unknown>


export function useGetApiWorkPreparationCompletionDefinitionsRescuePlan<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkPreparationCompletionDefinitionsRescuePlan<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkPreparationCompletionDefinitionsRescuePlan<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkPreparationCompletionDefinitionsRescuePlan<TData = Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkPreparationCompletionDefinitionsRescuePlan>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkPreparationCompletionDefinitionsRescuePlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiWorkPreparationProjectIdSignScaffoldingSelfControl = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlSignResult>(
      {url: `/api/work-preparation/${projectId}/sign-scaffolding-self-control`, method: 'POST', signal
    },
      );
    }




export const getPostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationKey = () => ['postApiWorkPreparationProjectIdSignScaffoldingSelfControl'] as const;

export const getPostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignScaffoldingSelfControl>>, TError,PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignScaffoldingSelfControl>>, TError,PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationVariables, TContext> => {

const mutationKey = getPostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignScaffoldingSelfControl>>, PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiWorkPreparationProjectIdSignScaffoldingSelfControl(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignScaffoldingSelfControl>>>

    export type PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationError = ErrorType<unknown>
    export type PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationVariables = {projectId: number}

    export const usePostApiWorkPreparationProjectIdSignScaffoldingSelfControl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignScaffoldingSelfControl>>, TError,PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignScaffoldingSelfControl>>,
        TError,
        PostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiWorkPreparationProjectIdSignScaffoldingSelfControlMutationOptions(options), queryClient);
    }
    export const postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlSignResult>(
      {url: `/api/work-preparation/${projectId}/sign-weather-protection-self-control`, method: 'POST', signal
    },
      );
    }




export const getPostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationKey = () => ['postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl'] as const;

export const getPostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl>>, TError,PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl>>, TError,PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationVariables, TContext> => {

const mutationKey = getPostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl>>, PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl>>>

    export type PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationError = ErrorType<unknown>
    export type PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationVariables = {projectId: number}

    export const usePostApiWorkPreparationProjectIdSignWeatherProtectionSelfControl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl>>, TError,PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkPreparationProjectIdSignWeatherProtectionSelfControl>>,
        TError,
        PostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiWorkPreparationProjectIdSignWeatherProtectionSelfControlMutationOptions(options), queryClient);
    }
